const userTypeConstant = {
    UNDERWRITER : 'Underwriter',
    AGENT : 'Agent',
    SYSTEMUSER: 'SystemUser',
    SERVICEUSER: 'ServiceUser'

};

angular.module('umCore')
    .constant('userTypeConstant', userTypeConstant);
